exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-thanks-tsx": () => import("./../../../src/pages/thanks.tsx" /* webpackChunkName: "component---src-pages-thanks-tsx" */),
  "component---src-templates-page-builder-template-tsx": () => import("./../../../src/templates/page-builder-template.tsx" /* webpackChunkName: "component---src-templates-page-builder-template-tsx" */)
}

